class QuoteSlider extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
        this.lightroomInit = false;
        this.sliderOptions = {
            slides: {
                perView: 1,
                spacing: 20,
                origin: "center",
            },
            detailsChanged: (s) => {
                s.slides.forEach((element, idx) => {
                    element.style.opacity = s.track.details.slides[idx].portion
                })
            },
            renderMode: "custom",
        }

        this.thumbOptions = {
            slides: {
                perView: 4,
                spacing: 20,
            },
            breakpoints: {
                "(max-width: 639px)": {
                    slides: {
                        origin: "center",
                        perView: 2,
                        spacing: 10,
                    },
                },
            }
        }

        this.onInit();

    }

    onInit() {

        this.slider = new KeenSlider('.quote-slider', this.sliderOptions, [
            (sliderMain) => {
                let timeout
                let mouseOver = false
                function clearNextTimeout() {
                    clearTimeout(timeout)
                }
                function nextTimeout() {
                    clearTimeout(timeout)
                    if (mouseOver) return
                    timeout = setTimeout(() => {
                        sliderMain.next()
                    }, 3000)
                }
                function firstTimeout() {
                    clearTimeout(timeout)
                    if (mouseOver) return
                    timeout = setTimeout(() => {
                        if (sliderMain.track.details.rel == (sliderMain.track.details.slides.length - 1)) {
                            sliderMain.moveToIdx(0);
                        } else {
                            sliderMain.next()
                        }
                    }, 3000)
                }

                sliderMain.on("created", () => {
                    sliderMain.container.addEventListener("mouseover", () => {
                        mouseOver = true
                        clearNextTimeout()
                    })
                    sliderMain.container.addEventListener("mouseout", () => {
                        mouseOver = false
                        firstTimeout()
                    })
                    firstTimeout()
                })

                sliderMain.on("dragStarted", clearNextTimeout)
                sliderMain.on("animationEnded", firstTimeout)
                sliderMain.on("updated", firstTimeout)
            },
        ]);

        this.thumbnails = new KeenSlider('.quote-image-thumbs',
            this.thumbOptions,
            [this.onThumbnailPlugin(this.slider)]
        );
    }

    onDestroy() {
        this.slider.destroy();
        this.thumbnails.destroy();
    }

    onUpdate() {
        this.onDestroy();
        this.onInit();
    }

    onThumbnailPlugin(main) {
        return (slider) => {
            function removeActive() {
                slider.slides.forEach((slide) => {
                    slide.classList.remove("active")
                })
            }
            function addActive(idx) {
                slider.slides[idx].classList.add("active")
            }

            function addClickEvents() {
                slider.slides.forEach((slide, idx) => {
                    slide.addEventListener("click", () => {
                        main.moveToIdx(idx)
                    })
                })
            }

            slider.on("created", () => {
                addActive(slider.track.details.rel)
                addClickEvents()
                main.on("animationStarted", () => {
                    removeActive()
                    const next = main.animator.targetIdx || 0
                    addActive(main.track.absToRel(next))
                    slider.moveToIdx(next)
                })
            })
        }
    }

}

customElements.define('quote-slider', QuoteSlider);  